import type { ReactNode } from "react";
import { type StyleProp, type TextStyle, type ViewStyle } from "react-native";
import { Row } from "./Row";

export type DocumentRowProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  leadingMeta?: ReactNode;
  leading?: ReactNode;
  titleRight?: ReactNode;
  trailing?: ReactNode;
  onPress?: () => void;
  showChevron?: boolean;
  accessibilityLabel?: string;
  /** Stable analytics identifier; the row's title travels as the label. */
  action?: string;
  leadingMetaWidth?: number;
  titleNumberOfLines?: number;
  subtitleNumberOfLines?: number;
  style?: StyleProp<ViewStyle>;
  titleStyle?: StyleProp<TextStyle>;
  subtitleStyle?: StyleProp<TextStyle>;
};

/** Canonical glass row for document, medication, and test-result actions. */
export function DocumentRow({
  title,
  subtitle,
  leadingMeta,
  leading,
  titleRight,
  trailing,
  onPress,
  showChevron,
  accessibilityLabel,
  action = "document_row",
  leadingMetaWidth = 42,
  titleNumberOfLines = 1,
  subtitleNumberOfLines = 2,
  style,
  titleStyle,
  subtitleStyle,
}: DocumentRowProps) {
  return (
    <Row
      leadingMeta={leadingMeta}
      leading={leading}
      leadingMetaWidth={leadingMetaWidth}
      leadingSize={34}
      title={title}
      subtitle={subtitle}
      titleNumberOfLines={titleNumberOfLines}
      subtitleNumberOfLines={subtitleNumberOfLines}
      titleRight={titleRight}
      trailing={trailing}
      onPress={onPress}
      action={action}
      accessibilityLabel={accessibilityLabel}
      chevron={showChevron ?? Boolean(onPress)}
      titleStyle={titleStyle}
      subtitleStyle={subtitleStyle}
      style={style}
    />
  );
}

export default DocumentRow;
